export default [{
        path: '/slider/add',
        name: 'Admin.Slider.Add',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Slider.Form" */
                '@/views/Slider/Form.vue'
            ),
        meta: {
            title: 'Slider Add Form',
            icon: "about"
        },
    },
    {
        path: '/slider/:id/edit',
        name: 'Admin.Slider.Edit',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Slider.Form" */
                '@/views/Slider/Form.vue'
            ),
        meta: {
            title: 'Slider Edit Form',
        },
    }
]